<template>
    <validation-provider :name="name" :vid="vid" :rules="rules" v-slot="{errors, dirty, valid, invalid}" tag="div"
                         class="form-group">
        <slot name="label">
            <label :for="name">{{ label }}</label>
        </slot>
        <slot name="input">
            <div class="input-wrapper">
                <input :type="type" :id="name" :name="name" :placeholder="placeholder" v-model="inputValue"
                       @focus="focus"
                       @blur="blur" @keyup="keyup" @keydown="keydown" @keypress="keypress">
                <svg-icon icon="check-circle-light" class="svg-valid" v-if="dirty && valid"></svg-icon>
                <svg-icon icon="exclamation-circle-light" class="svg-invalid" v-if="dirty && invalid"></svg-icon>
            </div>
        </slot>
        <slot name="errors">
            <span class="errors">{{ errors[0] }}</span>
        </slot>
    </validation-provider>
</template>

<script>
export default {
    name: 'form-input',
    props: {
        /**
         * Define o nome para a validação, também é utilizado como identificação do campo
         */
        name: {
            type: String,
            required: true,
        },

        /**
         * Define o vid de validação
         */
        vid: {
            type: String,
            required: true,
        },

        /**
         * Define o label do input
         */
        label: {
            type: String,
            value: '',
        },

        /**
         * Define as regras de validação do input
         */
        rules: {
            type: [String, Object],
            default: '',
        },

        /**
         * Define o tipo de input
         */
        type: {
            type: String,
            default: 'text',
            validator(value) {
                return ['text', 'password', 'email'].indexOf(value) !== -1;
            }
        },

        /**
         * Passa o valor através de um v-model
         */
        value: {
            type: [String, Number],
            default: '',
        },

        /**
         * Define um placeholder para o input
         */
        placeholder: {
            type: String,
            default: '',
        },

        /**
         * Se o campo for somente leitura
         */
        readOnly: {
            type: Boolean,
            default: false,
        },

        /**
         * Se o campo for desabilitado
         */
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            inputValue: '',
        }
    },
    methods: {
        /**
         * Emite o evento quando o campo tiver um input
         * @param event
         */
        input(event) {
            this.$emit('input', event.target.value);
        },

        /**
         * Emite o evento quando o campo tiver um blur
         * @param event
         */
        blur(event) {
            this.$emit('blur', event.target.value);
        },

        /**
         * Emite o evento quando o campo tiver um focus
         */
        focus(event) {
            this.$emit('focus', event.target.value);
        },

        /**
         * Emite o evento quando o campo tiver um keydown
         * @param event
         */
        keydown(event) {
            this.$emit('keydown', event.target.value);
        },

        /**
         * Emite o evento quando o campo tiver um keyup
         * @param event
         */
        keyup(event) {
            this.$emit('keyup', event.target.value);
        },

        /**
         * Emite o evento quando o campo tiver um keypress
         * @param event
         */
        keypress(event) {
            this.$emit('keypress', event.target.value);
        }
    },
    watch: {
        inputValue(value) {
            this.$emit('input', value);
        }
    },
    created() {
        if (this.value) {
            this.inputValue = this.value;
        }
    }
}
</script>

<style lang="scss" scoped>
.form-group {
    @apply flex flex-col;

    label {
        @apply text-sm font-bold text-black mb-1;
    }

    .input-wrapper {
        @apply w-full relative;

        input {
            @apply w-full text-sm py-2 px-3 border border-gray-300 rounded leading-normal transition-all duration-150 ease-in-out;

            &:focus {
                @apply outline-none shadow-md border-primary;
            }
        }

        .svg-valid, .svg-invalid {
            @apply absolute;
            right: 10px;
            bottom: 10px;

        }

        .svg-valid {
            @apply text-success;
        }

        .svg-invalid {
            @apply text-danger;
        }
    }

}

</style>
